@if(complexSteps?.length) {
<div class="b-a b-col-5 m-t _complex-container b-r-0-s b-r-0-m b-l-0-s b-l-0-m">
    @for(step of complexSteps; track step.id){
    <div [class]="$last? 'b-b b-col-5' : ''">
        <button type="button"
                (click)="toggleService.toggle([toggleId, $index])"
                class="p-t-3 p-b-3 p-l-2 p-r-2 p-l-4-s p-l-4-m p-r-4-s p-r-4-m flex flex-justify-between flex-middle w-12">
            <span class="flex flex-middle">
                <span style="border-radius: 100%; width: 29px; height: 29px;"
                      class="s1 bg-col-62 flex flex-middle flex-justify-center">{{$index + 1}}</span>
                <span class="m-l-2 s1">{{step.title | translate}}</span>
            </span>
            <i class="_icon flex"
               style="font-size: 20px;"
               [toggleClass]="'icon-chevron-up !icon-chevron-down'"
               [toggleClassBy]="toggleService.getState([toggleId, $index])"></i>
        </button>
        <hide-up [open]="toggleService.getState([toggleId, $index])">
            <div class="p-r-2 p-l-2 p-l-4-s p-l-4-m p-r-4-s p-r-4-m p-t-1 p-b-3">
                @for(option of step.options; track option.attribute.id){
                <ng-container *ngTemplateOutlet="title, context: { $implicit: option}"></ng-container>
                <div [ngClass]="{'m-b' : !$last}">
                    @if(option.attribute.data?.isSwatch) {
                    <div [grid]="isSM ? 3 : 5"
                         class="m-t-2 p-r-12-s p-r-12-m"
                         [gridColumnGap]="'16px'"
                         [gridRowGap]="'8px'">
                        @for(item of option.values; track item.value) {
                        <div>
                            <button type="button"
                                    class="flex w-12"
                                    [gridColumn]="1"
                                    (click)="configuration.select(option.attribute.id, item.value)">
                                <span class="w-12">
                                    <product-view-swatch [selected]="configuration.isSelected(option.attribute.id, item.value)"
                                                         [disabled]="!!item.error"
                                                         [attributeCode]="option.attribute.id"
                                                         [value]="item.value">
                                    </product-view-swatch>
                                    <div class="m-t-1 center p2">
                                        {{item.value | optionLabel : option.attribute.id}}
                                    </div>
                                    @if(item.additionalPrice){
                                    <div class="center flex flex-middle flex-justify-center"
                                         style="line-height: normal;">
                                        <span class="p2 col-3 flex flex-middle">
                                            +<price [value]="item.additionalPrice"
                                                   [precision]="2"></price>
                                        </span>
                                        @if(additionalLeadTime){
                                        <product-view-tooltip class="m-l-1"
                                                              [direction]="$index ? 'left' : 'right'"
                                                              [width]="isSM ? 150 : 206"
                                                              [fontSize]="isSM ? '22px' : '16px'">
                                            <span>{{additionalLeadTime}}</span></product-view-tooltip>
                                        }
                                    </div>
                                    }
                                </span>
                            </button>
                        </div>
                        }
                    </div>
                    } @else {
                    <ng-container
                                  *ngTemplateOutlet="standardOptions, context: { $implicit: option, grid: useGrid(option.attribute.id)}"></ng-container>
                    }
                    @if(option.bottomText){
                    <p class="c1 col-11 m-t-2">{{option.bottomText | translate}}</p>
                    }
                    @if(option.displayCustomOptions?.(option)){
                    <product-view-custom-options-complex class="block"
                                                         [allowedOptions]="option.customOptions || []"></product-view-custom-options-complex>
                    }
                </div>
                }

                @if(step.id == complexStepsIds.fabric){
                @if (configuration.hasCustomOptions) {
                <product-view-custom-options-complex class="block"
                                                     [forbiddenOptions]="['Z-Clip Orientation']"></product-view-custom-options-complex>
                @if(content){
                @if(content.getSampleUrl && content.getSampleTitle){
                <href class="b-a b-col-5 w-12 m-t bg-col-52-s bg-col-52-m"
                      style="border-radius: 12px;"
                      [hrefClass]="'w-12'"
                      [link]="content.getSampleUrl">
                    <span class="flex flex-justify-between flex-middle w-12 p-l p-r p-t-2 p-b-2">
                        <span>
                            <span class="m-b-1 block p1"
                                  style="line-height: 17px;">{{content.getSampleTitle}}</span>
                            <span class="c1 col-11"
                                  style="line-height: 13px;">{{content.getSampleSubtitle}}</span>
                        </span>
                        <i class="flex icon-sample"
                           [ngStyle]="isSM ? {'fontSize' : '28px'} : {'fontSize' : '32px'}"></i>
                    </span>
                </href>
                }
                }
                }
                }
            </div>
        </hide-up>
    </div>
    }
</div>

} @else if(options) {
<div class="p-t wrap-s wrap-m">
    @for(option of options; track option.attribute.id) {
    <ng-container *ngTemplateOutlet="title, context: { $implicit: option}"></ng-container>

    @if(option.attribute.data?.isSwatch) {
    <div class="m-t-2 b-a b-col-51 p-a-2 bg-col-52 overflow-hidden"
         [ngClass]="{'m-b' : !$last}"
         style="box-shadow: 0px 0px 18px 0px #00000014 inset; border-radius: 12px;">
        @if(isSM){
        <carousel class="default-swiper swiper-slide-per-view product-view-configurable-options-swiper"
                  style="overflow: visible;"
                  [slidesPerView]="'auto'"
                  [scrollbar]="{ draggable: true }"
                  [freeMode]="true"
                  [style.--pc-slides-ceil]="pcSlidesCeil"
                  [style.--pc-slides]="pcSlides"
                  [style.--pc-gutter]="'16px'"
                  imageViewRoot>

            @for(item of option.values; track item.value) {
            <ng-template carouselSlide>
                <button type="button"
                        class="w-12 flex"
                        [gridColumn]="1"
                        (click)="configuration.select(option.attribute.id, item.value)">
                    <span class="flex-column w-12">
                        <product-view-swatch [disabled]="!!item.error"
                                             [selected]="configuration.isSelected(option.attribute.id, item.value)"
                                             [attributeCode]="option.attribute.id"
                                             [value]="item.value">
                        </product-view-swatch>
                        <span class="m-t-1 center p2">
                            {{item.value | optionLabel : option.attribute.id}}
                        </span>
                    </span>
                </button>
            </ng-template>
            }
        </carousel>
        } @else {

        <div [grid]="5"
             style="max-height: 211px; height: auto; overflow: auto"
             class="custom-scrollbar p-r-7"
             [gridColumnGap]="'16px'"
             [gridRowGap]="'8px'">
            @for(item of option.values; track item.value) {
            <button type="button"
                    class="w-12 flex"
                    [gridColumn]="1"
                    (click)="configuration.select(option.attribute.id, item.value)">
                <span class="flex-column w-12">
                    <product-view-swatch [disabled]="!!item.error"
                                         [zoom]="true"
                                         [selected]="configuration.isSelected(option.attribute.id, item.value)"
                                         [attributeCode]="option.attribute.id"
                                         [title]="(item.value | optionLabel : option.attribute.id) + ''"
                                         [subtitle]="fabricStyle ? (fabricStyle | optionLabel : 'fabric_style') + '' : ''"
                                         [value]="item.value">
                    </product-view-swatch>
                    <span class="m-t-1 center p2">
                        {{item.value | optionLabel : option.attribute.id}}
                    </span>
                </span>
            </button>
            }
        </div>
        }
    </div>
    } @else {
    <div [ngClass]="{'m-b' : !$last}"
         class="p-r-4-x p-r-4-l">
        <ng-container
                      *ngTemplateOutlet="standardOptions, context: { $implicit: option, grid: useGrid(option.attribute.id)}"></ng-container>
    </div>
    }
    }
</div>
}

<ng-template #title
             let-option>
    <div class="flex">
        <!-- h2, not h6: these sit directly under the product's h1, and h6 made
             the document skip five levels. Typography comes from the spans
             inside, and element-level heading styles are scoped to .cms-html,
             so the tag change is semantic only. -->
        <h2 class="flex-grow">
            @if(configuration.hasSelection(option.attribute.id)) {
            <span class="s1">{{ option.attribute.data!.label }}:&nbsp;</span>
            <span class="p1">{{ configuration.getSelection(option.attribute.id) | optionLabel : option.attribute.id
                }}</span>
            }@else {
            <span class="s1">{{'Select a %' | translate : option.attribute.data!.label }}</span>
            }
        </h2>
    </div>
</ng-template>

<ng-template #standardOptions
             let-option
             let-grid="grid">
    @if(grid){

    <div [grid]="isSM ? 3 : 5"
         class="m-t-2"
         [gridColumnGap]="'8px'"
         [gridRowGap]="'8px'">

        @for(item of option.values; track item.value) {
        <button type="button"
                (click)="configuration.select(option.attribute.id, item.value)">
            <box [selected]="configuration.isSelected(option.attribute.id, item.value)"
                 [disabled]="!!item.error"
                 [borderRadius]="true"
                 class="inline-block va-m w-12">
                {{item.value | optionLabel : option.attribute.id}}
            </box>
        </button>
        }
    </div>
    } @else {
    <div class="flex flex-middle flex-wrap">
        @for(item of option.values; track item.value) {
        @if(item.product?.data?.url && item.isCrosssell){
        <button type="button"
                (click)="selectCrosssell(item.product)"
                class="m-r-2 m-t-2">
            <box [borderRadius]="true"
                 [selected]="isCrosssellSelected(option, item)"
                 class="inline-block va-m">
                {{item.value | optionLabel : option.attribute.id}}
            </box>
        </button>
        } @else {

        <button type="button"
                class="m-r-2 m-t-2"
                (click)="configuration.select(option.attribute.id, item.value)">
            <box [selected]="configuration.isSelected(option.attribute.id, item.value)"
                 [disabled]="!!item.error"
                 [borderRadius]="true"
                 class="inline-block va-m">
                {{item.value | optionLabel : option.attribute.id}}
            </box>
        </button>
        }
        @if(item.additionalPrice){

        <span class="flex flex-middle flex-justify-center m-t-2 m-l--1 m-r-1"
              style="line-height: normal;">
            <span class="p2 col-3 flex flex-middle">
                +<price [value]="item.additionalPrice"
                       [precision]="2"></price>
            </span>
            @if(additionalLeadTime){
            <product-view-tooltip class="m-l-1"
                                  [direction]="$index ? 'left' : 'right'"
                                  [width]="isSM ? 150 : 206"
                                  [fontSize]="isSM ? '22px' : '16px'">
                <span>{{additionalLeadTime}}</span></product-view-tooltip>
            }
        </span>
        }

        }
    </div>
    }
</ng-template>